import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const getPricingTitleInternal = () => {
    const checkGate = checkFeatureFlagGate(
        featureFlags.gwp5810NonprofitPricingChanges
    );

    return checkGate
        ? "Nonprofit Pricing Page (May 30th 2025 updates)"
        : "Nonprofit Pricing Page";
};
